import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10">
      <div className="px-4 md:px-6 lg:px-8">
        <div className="max-w-[1440px] mx-auto">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-100">
              分类浏览
            </h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={cat.id === 'all' ? '/' : `/category/${cat.id}`}
                className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-background-200 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl text-primary-500`}></i>
                </div>
                <div className="text-center">
                  <h3 className="text-sm font-medium text-foreground-100 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">
                    {cat.description}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}